<div class="card">
  <div class="card-title">
    <h2>Monthly prospects overview by year
</h2>
  </div>
  <div class="prospect-summary-container">
    <p-accordion class="w-full" expandIcon="pi pi-plus" collapseIcon="pi pi-minus">
      <p-accordionTab header="ِMonthly prospects overview by year Table">
        <div class="group-cont">
          <div class="table-responsive">
            <p-table #dtMonthlyProspectSummary class="table" styleClass="ui-table-products" tableStyleClass="table table-responsive"
              [value]="monthlyProspectSummary" totalRecords="{{monthlyProspectSummary.length}}" [rows]="10" [showCurrentPageReport]="true"
              [rowsPerPageOptions]="[10, 25, 50]" [paginator]="true" [resizableColumns]="true"
              (onFilter)="onMonthlyTableFilter($event)"
              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries">
              <ng-template pTemplate="caption">
                <div style="text-align: right">
                  <button type="button" pButton icon="pi pi-file-excel" iconPos="left" label="EXCEL"
                    (click)="exportMonthlyProspectExcel()" style="margin-top: 0.5em; margin-right: 0.5em;"
                    class="ui-button-success"></button>
                  <button type="button" pButton icon="pi pi-file-pdf" iconPos="left" style="margin-top: 0.5em;"
                    (click)="exportMonthlyProspectPdf()" label="PDF" class="ui-button-warning"></button>
                </div>
              </ng-template>
              <ng-template pTemplate="header">
                <tr>
                  <th>#</th>
                  <th pSortableColumn="year" width="20%">Year
                    <p-sortIcon field="year"></p-sortIcon>
                  </th>
                  <th pSortableColumn="month" width="20%">Month
                    <p-sortIcon field="month"></p-sortIcon>
                  </th>
                  <th pSortableColumn="countOfProspects" width="30%">Prospect Count
                    <p-sortIcon field="countOfProspects"></p-sortIcon>
                  </th>
                  <th pSortableColumn="countOfActivities" width="30%">Activity Count
                    <p-sortIcon field="countOfActivities"></p-sortIcon>
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th>
                    <p-columnFilter field="year" type="numeric" display="menu" placeholder="Year"></p-columnFilter>
                  </th>
                  <th>
                    <p-columnFilter field="month" type="text" display="menu" placeholder="Month"></p-columnFilter>
                  </th>
                  <th>
                    <p-columnFilter field="countOfProspects" type="numeric" display="menu" placeholder="Prospect Count"></p-columnFilter>
                  </th>
                  <th>
                    <p-columnFilter field="countOfActivities" type="numeric" display="menu" placeholder="Activity Count"></p-columnFilter>
                  </th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-summary let-i="rowIndex">
                <tr>
                  <td>{{i + 1}}</td>
                  <td>{{summary.year}}</td>
                  <td>{{getMonthName(summary.month)}}</td>
                  <td>{{summary.countOfProspects}}</td>
                  <td>{{summary.countOfActivities}}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
      </p-accordionTab>
    </p-accordion>
  </div>
  <div class="card">
    <div class="card-title">
      <h2>Monthly prospects overview by year</h2>
    </div>
    <div class="cont" style="width: 100%;">
      <div class="p-grid" style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 20px; width: 100%;">
        <div class="p-col-6" style="flex: 1; padding: 0 5px;">
          <label for="groupByYear">Year:</label>
          <p-dropdown id="groupByYear" [options]="yearOptions" [(ngModel)]="selectedYear"
            (onChange)="onYearChange()" optionLabel="label" optionValue="value" placeholder="All Years">
          </p-dropdown>
        </div>
        <div class="p-col-6" style="flex: 1; padding: 0 5px;">
          <label for="countType">Data Type:</label>
          <p-dropdown id="countType" [options]="countTypeOptions" [(ngModel)]="selectedCountType"
            (onChange)="onCountTypeChange()" optionLabel="label" optionValue="value">
          </p-dropdown>
        </div>
      </div>
      <div style="width: 100%;">
        <p-chart #monthlyProspectChart type="line" [data]="monthlyProspectChartData" [options]="monthlyProspectChartOptions"
          height="380px" width="100%"></p-chart>
      </div>
      <div style="margin-top: 1em;">
        <button type="button" (click)="exportMonthlyProspectChartAsImage()" class="export-button">
          Export Chart as PNG
        </button>
        <button type="button" (click)="exportMonthlyProspectChartAsPDF()" class="export-button">
          Export Chart as PDF
        </button>
      </div>
    </div>
  </div>
</div>